import { render } from "./newUserInfo.vue?vue&type=template&id=30386dc3&scoped=true"
import script from "./newUserInfo.vue?vue&type=script&lang=js"
export * from "./newUserInfo.vue?vue&type=script&lang=js"

import "./newUserInfo.vue?vue&type=style&index=0&id=30386dc3&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30386dc3"]])

export default __exports__